var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { createRef, useMemo, useState, } from 'react';
import { BACKSPACE_KEY } from '#constants';
const SEPARATORS = /[\s-]/g;
const NON_DIGITS = /\D/g;
/*
    Splits by old value - if the result from the split has
    a new value of or non empty string one returns, otherwise old value
    Example: newValue = '12' oldValue = '1' -> split -> '2'
 */
const getNewValue = (newValue, oldValue) => newValue.split(oldValue).join('') || oldValue;
export const useCodeInput = ({ isNumeric, length, onCompletion, }) => {
    _react_refresh_temp_1();
    const [values, setValues] = useState(Array(length).fill(''));
    const inputRefs = useMemo(() => Array(length)
        .fill('')
        .map(() => createRef()), [length]);
    const executeOnCompletion = (value) => {
        const joinedValue = value.join('');
        if (joinedValue.length === length) {
            void onCompletion(joinedValue);
        }
    };
    // Codes are often copied as "123 456" or "ABCD-1234"
    const sanitize = (raw) => {
        const compact = raw.replace(SEPARATORS, '');
        return isNumeric ? compact.replace(NON_DIGITS, '') : compact;
    };
    const fill = (data) => {
        const newValue = values.map((_v, i) => data[i] || '');
        setValues(newValue);
        inputRefs[data.length]?.current?.focus();
        executeOnCompletion(newValue);
    };
    const onPaste = (e) => {
        e.preventDefault();
        if (!e.clipboardData) {
            return;
        }
        fill(sanitize(e.clipboardData.getData('text/plain')));
    };
    const onChange = (e, i) => {
        const data = sanitize(e.target.value);
        // Autofill drops the whole code into one box
        if (data.length > (values[i]?.length ?? 0) + 1) {
            fill(data);
            return;
        }
        const newValue = getNewValue(data, values[i] || '');
        const input = inputRefs[i]?.current;
        const nextInput = inputRefs[i + 1]?.current;
        if (input && newValue) {
            input.value = newValue;
            const newValues = [...values];
            newValues[i] = newValue;
            setValues(newValues);
            if (!nextInput) {
                executeOnCompletion(newValues);
            }
            else {
                nextInput.focus();
            }
        }
    };
    const onKeyDown = (e, i) => {
        if (e.key === BACKSPACE_KEY) {
            const prevInput = inputRefs[i - 1]?.current;
            e.preventDefault();
            if (values[i]) {
                const newValues = [...values];
                newValues[i] = '';
                setValues(newValues);
            }
            prevInput?.focus();
        }
    };
    return { values, onChange, onKeyDown, inputRefs, onPaste };
};
_react_refresh_temp_1(useCodeInput, "8FVG/RVLvNo/ubY6/31NZ5DreEE=");
